module.exports = __webpack_public_path__ + "img/9788982733932.9fab6472.jpg";